import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useAuthStore } from '../store'
import { Auth } from 'aws-amplify'
import { api } from '../api'

const isAuthenticated = async (): Promise<boolean> => {
  try {
    const user = await Auth.currentAuthenticatedUser()
    console.log('User is signed in:', user)
    return true
  } catch {
    console.log('User is not signed in')
    return false
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

const getUserRoutes = async () => {
  const { userDept, userProfile, setProfile } = useAuthStore()

  if (!userDept) return []

  if (userProfile && userProfile.length > 0) {
    return userProfile
  }

  try {
    const { data } = await api.get(`/profile-user-api?id=${userDept}`)

    const [department] = data
    setProfile(department?.routes || [])
    return department?.routes || []
  } catch (error) {
    console.error('Error fetching user routes:', error)
    return []
  }
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  if (requiresAuth) {
    const hasSession = await isAuthenticated()

    if (hasSession) {
      const userRoutes = await getUserRoutes()

      if (userRoutes?.includes(to.name) || to.name == 'home') {
        return next()
      } else {
        return next('/home')
      }
    } else {
      return next('/login')
    }
  } else {
    return next()
  }
})

export default router
